import clsx from 'clsx';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ClientMatchedResponse, ClientTextReviewResponse } from '@vestico/model';

import { BorderContainer, CustomCSSProperties } from '@vestico/shared';
import globalStyle from '@vestico/shared/src/layouts/utils.module.css';

import { PostLikeHeart } from './OverlayIcons/PostLikeHeart';
import { SizeRecIcon } from './OverlayIcons/SizeRecIcon';
import style from './ReviewDetailsHeader.module.css';

export interface ReviewDetailsHeaderProps {
  response: ClientMatchedResponse | ClientTextReviewResponse;
  headerMarginRight?: number;
  showLikeInteraction?: boolean;
  showSizeRecToggle?: boolean;
  onSizeRecToggle?: () => void;
}

export const ReviewDetailsHeader = ({
  response,
  headerMarginRight,
  showLikeInteraction,
  showSizeRecToggle,
  onSizeRecToggle,
}: ReviewDetailsHeaderProps) => {
  const { userName } = response;
  const { t } = useTranslation();

  const headerLineValueString = useMemo(() => userName, [userName]);

  if (!headerLineValueString && !showLikeInteraction) {
    return null;
  }

  return (
    <>
      <div
        className={clsx(style.root)}
        style={headerMarginRight ? ({ '--review-detail-header-margin-right': `${headerMarginRight}px` } as CustomCSSProperties) : undefined}
      >
        {headerLineValueString ? (
          <div>
            <div className={clsx(style.title, globalStyle.textLarge, globalStyle.textBold)}>
              <bdi>{t('LOC_VALUE', { value: headerLineValueString })}</bdi>
            </div>
          </div>
        ) : null}
        <div className={clsx(style.buttons)}>
          {showSizeRecToggle && onSizeRecToggle ? (
            <SizeRecIcon looseWidth colorScheme="dark" disableShadows size="small" onClick={onSizeRecToggle} />
          ) : null}
          {showLikeInteraction ? <PostLikeHeart response={response} size="small" colorScheme="dark" disableShadows /> : null}
        </div>
      </div>
      <div>
        <BorderContainer fullWidth topPadding="0" />
      </div>
    </>
  );
};
